import callApiAxiosClient from "../../axios/axios_client";
import { evolutionIndex } from "../../models";


async function peopleCountingEvolutionIndex(): Promise<evolutionIndex> {
    const token = JSON.parse(localStorage.getItem('user')!)
    const authorization = 'Bearer ' + token.token
    return callApiAxiosClient<evolutionIndex>({
        method: "get",
        url: "programmability/evolution-index",
        headers: {
            "Content-Type": "Application/json",
            "Authorization": authorization

        }
    })
}
export default peopleCountingEvolutionIndex;